import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';

import CheckboxFilter from './CheckboxFilter';

import { toggleCheckboxFilter as toggleCheckboxFilterAction } from './CheckboxFilterActions';

export function CheckboxFilterContainer(props) {
  const { filter, toggleCheckboxFilter } = props;
  const onChange = useCallback(() => {
    toggleCheckboxFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return <CheckboxFilter {...props} onChange={onChange} />;
}

CheckboxFilterContainer.propTypes = {
  filter: PropTypes.instanceOf(Map),
  toggleCheckboxFilter: PropTypes.func,
};

const mapDispatchToProps = {
  toggleCheckboxFilter: toggleCheckboxFilterAction,
};

export default connect(null, mapDispatchToProps)(CheckboxFilterContainer);
